import { render, staticRenderFns } from "./ArchivedApplications.vue?vue&type=template&id=65a18b73"
import script from "./ArchivedApplications.vue?vue&type=script&lang=js"
export * from "./ArchivedApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports